import React from "react";
import ReactDOM from "react-dom";
import { reatomContext, useAtom } from '@reatom/npm-react';
import { createCtx } from "@reatom/core";
import ScoreTableBtn from "./scoreTableBtn";
import { streamVisibleAtom } from "./models";

const $video_container = document.getElementById('react-video-container')
const $show_stream_button = document.getElementById('react-show-translation-btn')
const stream_url = window?.URLS?.stream;
const ctx = createCtx()
const ref_stream_container = React.createRef()

function VideoContainer({url, atom_visible}){
    const [streamVisible, ] = useAtom(atom_visible)

    if(!streamVisible){
        return ''
    }

    return (
        <div className="video-container match__stats-content__video">
            <iframe type="text/html" width="640" height="360"
                loading="lazy"
                src={url}
                frameborder="0"
                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                referrerpolicy="strict-origin-when-cross-origin"
                allowfullscreen
            ></iframe>
        </div>
    )
}

function CommonLogic({}){
    // const ref = React.createRef()
    return (
        <reatomContext.Provider value={ctx}>
            {$video_container && stream_url && (
                <>
                    {ReactDOM.createPortal(
                        <div ref={ref_stream_container}>
                            <div className="container-spacer">
                                <div className="container-body">
                                    <VideoContainer 
                                        url={stream_url}
                                        atom_visible={streamVisibleAtom}
                                    />
                                </div>
                            </div>
                        </div>,
                        $video_container
                    )}

                    {ReactDOM.createPortal(
                      <ScoreTableBtn 
                        root={$show_stream_button}
                        table={ref_stream_container}
                        stroke
                        atom={streamVisibleAtom}
                        />,
                      $show_stream_button
                    )}
                </>
            )}
        </reatomContext.Provider>
    )
}

export default CommonLogic